import {SaveSaleVehicleFinancingBody, VehicleFinancingType} from '@dms/api/vehicle';
import {RATE_MATRIX_TERMS} from '@dms/features/vehicle-financing-template';

interface CreateManualFinancingBodyOptions {
  isGermanTenant: boolean;
}

/**
 * An empty manual configuration, the starting point of a financing set up by hand.
 *
 * A German tenant starts with an explicit fixed interest rate: the interest rate type field shows
 * "fixed" for a manual configuration without a value, and the backend derives no default, so the
 * stored value has to match what the user sees.
 */
export function createManualFinancingBody(
  type: VehicleFinancingType,
  options: CreateManualFinancingBodyOptions
): SaveSaleVehicleFinancingBody {
  return {
    type,
    mode: 'MANUAL',
    templateId: null,
    financialInstitutionCodeId: null,
    validTo: null,
    rateMatrix: {
      // Copied, not shared: `RATE_MATRIX_TERMS` is one module-level array, so handing it out would
      // let a term change in one draft reach every other draft and the template editor.
      availableTerms: [...RATE_MATRIX_TERMS],
      cells: [],
    },
    activeTerm: null,
    activeDownPayment: null,
    activeBalloonPayment: null,
    processingFeeOverride: null,
    interestRateTypeOverride: options.isGermanTenant ? 'FIXED' : null,
    vehicleTransferIncludedOverride: null,
    vehicleTransferAmountOverride: null,
    vehicleRegistrationIncludedOverride: null,
    vehicleRegistrationAmountOverride: null,
    vehicleDeliveryIncludedOverride: null,
    vehicleDeliveryAmountOverride: null,
    tradeInPossibleOverride: null,
    creditProtectionIncluded: false,
    insuranceIncludedInCalculation: false,
    liabilityInsuranceMonthly: null,
    liabilityInsuranceDeductible: null,
    comprehensiveInsuranceMonthly: null,
    comprehensiveInsuranceDeductible: null,
  };
}
